import SparkMD5 from 'spark-md5'
export function CalSum (array, result) {
  for (var i = 1; i < 1 << array.length; i++) { // 从1循环到2^N
    var sum = 0
    var temp = ''
    for (var j = 0; j < array.length; j++) {
      // 用i与2^j进行位与运算，若结果不为0,则表示第j位不为0,从数组中取出第j个数
      if ((i & 1 << j) !== 0) {
        sum += array[j]
        temp += array[j] + '+'
      }
    }
    if (sum === result) {
      var t = temp.split('+')
      var p = []
      for (let j = 0; j < t.length; j++) {
        if (t[j] !== '') {
          p.push(Number(t[j]))
        }
      }
      // console.log(p)
    }
  }
  return p
}
export function findColorById (id) {
  let color = ''
  let text = ''
  switch (id) {
    case 2:
      color = '#00FFF0'
      text = 'Pucker'
      break
    case 3:
      color = '#FFC700'
      text = 'IRC'
      break
    case 4:
      color = '#FF00B8'
      text = 'SRF'
      break
    case 5:
      color = '#FF4C00'
      text = 'RPED'
      break
    case 6:
      color = '#0094FF'
      text = 'RPE atrophy'
      break
    // case 'F6':
      // color = '#AE6EFF'
      // text = 'Skip'
    //   break
    case 8:
      color = '#03FF4A'
      text = 'SRHM'
      break
    case 9:
      color = '#FFF859'
      text = 'Drusen'
      break
    case 1:
      color = '#FFAAF1'
      text = 'HF'
      break
    default:
      break
  }
  const obj = {
    color: color,
    text: text
  }
  return obj
}

export function getTxtData (res) {
  const arr = [1, 2, 4, 8, 16, 32]

  let data = []
  if (res.includes('\r\n')) {
    data = res.split('\r\n')
  } else if (res.includes('\n')) {
    data = res.split('\n')
  }
  let diagnosis = {}
  const list = []
  let approved = false
  let poorQuality = 0
  // console.log('data', data)
  data.forEach((item, index) => {
    // console.log(item)
    if (index === 0 && item.length < 10) {
      const li = item.split(' ')
      if (li[0] && li.length === 2) {
        const obj = {
          dia: Number(li[0]) === 0 ? [0] : CalSum(arr, Number(li[0])),
          doctor: li[1]
        }
        diagnosis = obj
      }
    } else if (item.includes('.txt')) {
      approved = true
    } else if (item.includes('poorQuality')) {
      const poorQualityli = item.split(' ')
      poorQuality = poorQualityli[1]
      console.log(poorQuality)
    } else if (item.length > 15) {
      const li = String(item).split('  ')
      // console.log('Number(li[3])', Number(li[3]))
      // console.log('li', li)
      const lii = li[0].split(' ')
      const re = findColorById(Number(lii[0]))
      if (li[1]) { // 不是approve
        const zuobiao = li[1].split('  ')
        const style = li[2] ? JSON.parse(li[2]) : undefined
        let direction = 0
        if (Array.isArray(style)) {
          direction = Number(li[3])
        } else {
          direction = Number(style)
        }
        const obj = {
          id: Number(lii[0]),
          x: Number(lii[1]),
          y: Number(lii[2]),
          w: Number(lii[3]),
          h: Number(lii[4]),
          doctor: String(zuobiao[0]).includes('AI') ? '' : zuobiao[0],
          color: re.color,
          text: re.text,
          originWidth: 0,
          originHeight: 0,
          direction: direction || 0
        }
        // console.log('zuobiao[0]', zuobiao[0])

        list.push(obj)
      }
    }
  })

  const resd = {
    diagnosis: diagnosis,
    list: list,
    approved: approved
  }
  return resd
//   return null
}

// 計算txt中的cx,cy,cw,ch
export function computedData (item, flag, styleList) {
  if (flag === 0) { /// 計算上傳坐標數據
    // 計算中心點坐標和寬高
    const x0 = ((item.x + item.w / 2) / (styleList.width / styleList.imgWidth_T)).toFixed(6)// 法二
    const y0 = ((item.y + item.h / 2) / (styleList.height / styleList.imgHeight_T)).toFixed(6)// 法二
    // 計算除以真實圖片寬高後的中心點坐標和w,h
    const x2 = Number((x0 / styleList.imgWidth_T).toFixed(6))
    const y2 = Number((y0 / styleList.imgHeight_T).toFixed(6))
    const w2 = Number((Math.abs(item.w) / styleList.width).toFixed(6))// 法二
    const h2 = Number((Math.abs(item.h) / styleList.height).toFixed(6))// 法二

    return { id: item.id, x: x2, y: y2, w: w2, h: h2, color: item.color, text: item.text, doctor: item.doctor, originWidth: item.originWidth, originHeight: item.originHeight, direction: item.direction }
    // return { id: item.id, x: x2, y: y2, w: w2, h: h2, doctor: item.doctor }
  } else { /// 計算顯示的坐標數據
    const iemw = 1
    const iemh = 1
    /// ****************图片按等比例展示后，不需要计算了
    // if (item.originWidth !== 0) {
    //   if (item.originWidth && item.originWidth >= styleList.width) {
    //     iemw = Number((item.originWidth / styleList.width).toFixed(6))
    //     iemh = Number((item.originHeight / styleList.height).toFixed(6))
    //   } else if (item.originWidth) {
    //     iemw = Number((styleList.width / item.originWidth).toFixed(6))
    //     iemh = Number((styleList.height / item.originHeight).toFixed(6))
    //   }
    // }

    // console.log('iemw', iemw, item.originWidth, styleList.width)
    // console.log('iemh', iemh, item.originHeight, styleList.height)

    /// 計算中心坐標和寬高
    const x0 = Number((item.x * styleList.imgWidth_T * (styleList.width / styleList.imgWidth_T)).toFixed(6))
    const y0 = Number((item.y * styleList.imgHeight_T * (styleList.height / styleList.imgHeight_T)).toFixed(6))
    const w = Number((item.w * styleList.width / iemw).toFixed(0))
    const h = Number((item.h * styleList.height / iemh).toFixed(0))
    const x = Number(((x0 - w / 2) / iemw).toFixed(0))
    const y = Number(((y0 - h / 2) / iemh).toFixed(0))
    return { id: item.id, x: x, y: y, w: w, h: h, color: item.color, text: item.text, doctor: item.doctor, originWidth: item.originWidth, originHeight: item.originHeight, direction: item.direction }
  }
}
/// 計算圖片真實大小
export function getImgInfo (img1) {
  const img = new Image()
  img.src = img1
  let width = 0
  let height = 0
  const obj = {
    imgWidth_T: width,
    imgHeight_T: height
  }
  img.onload = function () {
    // imgWidth_T = img.width
    // imgHeight_T = img.height
    width = img.width
    height = img.height
    const obj = {
      imgWidth_T: width,
      imgHeight_T: height
    }
    // return obj
    console.log(obj)
  }
  return obj
}
/// 計算圖片真實大小
export function getImgStyle (img1) {
  return new Promise((resolve) => {
    const img = new Image()
    img.src = img1
    img.onload = function () {
      resolve({
        imgWidth_T: img.width,
        imgHeight_T: img.height
      })
    }
  })
}

/// /計算上傳文件的md5

/// 獲取文件對應的md5編碼
export function computeMD5 (param) {
  return new Promise((resolve) => {
    const file = param
    const sliceLength = 1024 * 1024 * 10/// // 切片默认大小10M
    let retMd5 = ''
    let chunkSize = 0
    if (file.size > sliceLength) {
      chunkSize = Math.ceil(file.size / sliceLength)
    } else {
      chunkSize = file.size
    }
    console.log('chunkSize', chunkSize)
    const fileReader = new FileReader()
    const md5 = new SparkMD5()
    let index = 0
    const loadFile = () => {
      const slice = file.slice(index, index + sliceLength)
      fileReader.readAsBinaryString(slice)
    }
    loadFile()
    fileReader.onload = e => {
      md5.appendBinary(e.target.result)
      if (index < file.size) {
        // console.log('切片', index)
        index += sliceLength
        loadFile()
      } else {
        retMd5 = md5.end()// 就是文件md5码
        resolve(retMd5)
      }
    }
  })
}

// 时间格式转化
export function dateFormat (fmt, date) {
  const opt = {
    'y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (const k in opt) {
    const ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
    };
  }
  return fmt
}

// 格式化时间 YY-MM--DD
export function formatTimeMills (timeMills) {
  const date = new Date(timeMills)
  let timeStr = date.getFullYear() + '-'
  if (date.getMonth() < 9) { // 月份从0开始的
    timeStr += '0'
  }
  timeStr += date.getMonth() + 1 + '-'
  timeStr += date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()
  // timeStr += ' '
  // timeStr += date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours()
  // timeStr += ':'
  // timeStr += date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes()
  // timeStr += ':'
  // timeStr += date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds()
  return timeStr
}
